import { configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authRducer from "./auth";
 import studentsRducer from "./students";
import resturantsReducer from "./resturant"
import MainMealsReducer from "./MainMeals"
import orderReducer from "./order"
import weekReducer from "./week"
import notesReducer from "./notes"
import ProfileReducer from "./Profile"
import settingsReducer from './settings'
const persistConfig = {
	key: "root",
	version: 1,
	storage,
};

const RootReducers = combineReducers({

	auth: authRducer,
  students:studentsRducer,
  resturants:resturantsReducer,
  mainMeals:MainMealsReducer,
order: orderReducer,
Profile: ProfileReducer,
week: weekReducer,
notes:notesReducer,
settings:settingsReducer




});

const persistedReducer = persistReducer(persistConfig, RootReducers);

export default configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});